import { useEffect, useState } from 'react';

import DialogName from '@/shared/types/dialogName.enum';

type Args = {
  amountOwed: number;
  variant: DialogName.ExternalTerminalPayment | DialogName.CashPayment;
};

const usePaymentForm = ({ amountOwed, variant }: Args) => {
  const [amountReceived, setAmountReceived] = useState('0');
  const [owedReceivedDifference, setOwedReceivedDifference] = useState('0');
  const [mode, setMode] = useState<'addition' | 'subtraction'>('addition');

  const cashAmountList = [5, 10, 20, 50, 100, 0.05, 0.1, 0.25];

  const onChangeOwedReceivedDifference = (value: string) => {
    if (!value || parseFloat(value) < amountOwed) {
      setOwedReceivedDifference('0');
    } else {
      setOwedReceivedDifference((parseFloat(value) - amountOwed).toFixed(2));
    }
  };

  const onAmountReceivedChange = (value: string) => {
    setAmountReceived(value);
    onChangeOwedReceivedDifference(value);
  };

  const onAddFixedAmount = (value: number) => {
    if (amountReceived) {
      const updatedValue = (parseFloat(amountReceived) + value).toFixed(2);
      setAmountReceived(updatedValue);
      onChangeOwedReceivedDifference(updatedValue);
    } else {
      setAmountReceived(value.toFixed(2));
      onChangeOwedReceivedDifference(value.toFixed(2));
    }
  };

  const onSubtractFixedAmount = (value: number) => {
    if (amountReceived) {
      const updatedValue = (parseFloat(amountReceived) - value).toFixed(2);
      setAmountReceived(updatedValue);
      onChangeOwedReceivedDifference(updatedValue);
    } else {
      setAmountReceived(value.toFixed(2));
      onChangeOwedReceivedDifference(value.toFixed(2));
    }
  };

  const onSetMode = (checked: boolean) => {
    setMode(checked ? 'addition' : 'subtraction');
  };

  useEffect(() => {
    if (variant === DialogName.ExternalTerminalPayment) {
      setAmountReceived(amountOwed.toFixed(2));
    }
  }, [amountOwed, variant]);

  return {
    owedReceivedDifference,
    amountReceived,
    cashAmountList,
    amountOwed,
    variant,
    mode,
    onAmountReceivedChange,
    onSubtractFixedAmount,
    onAddFixedAmount,
    onSetMode,
  };
};

export default usePaymentForm;
